import "./ProgressSpinner.scss";

function ProgressSpinner() {
    return (<div className="lds-ring"><div></div><div></div><div></div><div></div></div>);
}

export default ProgressSpinner;